var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"nav"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_c('router-link',{attrs:{"to":"/vacancies"}},[_vm._v("Vacatures")]),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("Contact")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }